module.exports = __webpack_public_path__ + "media/images/assignment/link_off-4d92d187caca840e06d6b190f8df29ae.svg";